/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import {
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
  SummaryState,
  IntegratedSummary,
  SearchState,
  IntegratedFiltering,
  GroupingState,
  IntegratedGrouping,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  Toolbar,
  VirtualTable,
  ExportPanel,
  TableColumnVisibility,
  ColumnChooser,
  TableSummaryRow,
  SearchPanel,
  TableGroupRow,
  DragDropProvider,
  TableColumnResizing,
} from '@devexpress/dx-react-grid-material-ui';
import { getRowId, updateOpDocRefNumbers } from '../../common';
import {
  calculateAmount,
  covertToDate,
  covertToTimeDateDigit,
  currencyFormatter,
  moneyFormat,
  opTimeFormatter,
  opTypeFormatter,
} from '../../Shared/colorFormat';
import {
  Box,
  Checkbox,
  colors,
  fade,
  Grid as MUIGrid,
  FormControlLabel,
  Typography,
  withStyles,
} from '@material-ui/core';
import { getMonthlyReport } from '../../graphql';
import { useLazyQuery } from '@apollo/client';
import { GridExporter } from '@devexpress/dx-react-grid-export';
import saveAs from 'file-saver';
import { getColumns } from '../../common/columns';
import { FinanceContext } from '../../contexts';
import FilterSelectCkeckBox from '../../Shared/FilterSelectCkeckBox';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { useReactToPrint } from 'react-to-print';
import { useDepartments, useEmployees, useTemplate } from '../../hooks';
import { SearchTable } from '../../components';
import usePrintTemplates from '../../hooks/usePrintTemplates';
import {
  getDefaultTemplate,
  getparentAccountsNames,
} from '../../common/helpers';
import PrintDownload from '../../Shared/PrintDownload';
import FilterSelectMulti from '../shared/FilterSelectMulti';
import useResourses from '../../hooks/useResourses';
import useTasks from '../../hooks/useTasks';
import { ReportGroupBySwitcher } from '../components/ReportGroupBySwitcher';
import { groupList } from '../constants/reports';
import { TableComponent2 } from './SalesReport';
import _ from 'lodash';

const styles = (theme: any) => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: fade(theme.palette.primary.main, 0.05),
    },
  },
});

const TableComponentBase = ({ classes, ...restProps }) => (
  <VirtualTable.Table {...restProps} className={classes.tableStriped} />
);
export const TableComponent = withStyles(styles, { name: 'TableComponent' })(
  TableComponentBase
);

export default function FinanceReport({
  isRTL,
  words,
  start,
  end,
  accounts,
  company,
  theme,
  drawerWidth,
}: any) {
  const [rows, setRows] = useState([]);
  const [isRaseed, setIsRaseed] = useState(false);
  const [credit, setCredit] = useState(0);
  const [debit, setDebit] = useState(0);

  const col = getColumns({ isRTL, words });

  const { tempoptions } = useTemplate();
  const { printtemplates } = usePrintTemplates();
  const { departments } = useDepartments();
  const { employeesfull: employees } = useEmployees();
  const { resourses } = useResourses();
  const { tasks } = useTasks();
  const mainaccounts = getparentAccountsNames();
  const [columns] = useState(
    [
      col.opTime,
      col.acc,
      col.opDocNo,
      col.refNo,
      col.opType,
      col.opAcc,
      col.customer,
      col.supplier,
      tempoptions?.contract && col.contract,
      tempoptions?.employee && col.employee,
      tempoptions?.department && col.department,
      tempoptions?.resourse && col.resourse,
      col.note,
      col.amount,
      col.amountdebit,
      col.amountcredit,
      col.rased,
    ].filter((x) => x)
  );

  const [tableColumnExtensions]: any = useState([
    { columnName: col.opTime.name, width: 100 },
    { columnName: col.acc.name, width: 120 },
    { columnName: col.opDocNo.name, width: 100 },
    { columnName: col.refNo.name, width: 100 },
    { columnName: col.opType.name, width: 150 },
    { columnName: col.customer.name, width: 200 },
    { columnName: col.supplier.name, width: 200 },
    { columnName: col.contract.name, width: 200 },
    { columnName: col.employee.name, width: 150 },
    { columnName: col.department.name, width: 150 },
    { columnName: col.resourse.name, width: 150 },
    { columnName: col.opAcc.name, width: 120 },
    { columnName: col.note.name, width: 200 },
    { columnName: col.amount.name, width: 150 },
    { columnName: col.amountdebit.name, width: 150 },
    { columnName: col.amountcredit.name, width: 150 },
    { columnName: col.rased.name, width: 150 },
  ]);
  const [getSummary, summaryData]: any = useLazyQuery(getMonthlyReport, {
    fetchPolicy: 'cache-and-network',
  });

  const {
    state: {
      accvalue,
      paccvalue,
      departvalue,
      resovalue,
      emplvalue,
      taskvalue,
      group,
      groupby,
      sumcolumn,
      sort,
      hiddenColumnNames,
    },
    dispatch,
  } = useContext(FinanceContext);
  const { height } = useWindowDimensions();

  const setAccvalueDispatch = (value: any) => {
    dispatch({ type: 'setAccvalue', payload: value ? [value] : [] });
  };
  const setPaccvalueDispatch = (value: any) => {
    dispatch({ type: 'setPaccvalue', payload: value ? [value] : [] });
  };

  const setDepartvalueDispatch = (value: any) => {
    dispatch({ type: 'setDepartvalue', payload: value });
  };
  const setEmplvalueDispatch = (value: any) => {
    dispatch({ type: 'setEmplvalue', payload: value });
  };
  const setResovalueDispatch = (value: any) => {
    dispatch({ type: 'setResovalue', payload: value });
  };
  const setTaskvalueDispatch = (value: any) => {
    dispatch({ type: 'setTaskvalue', payload: value });
  };
  const setGroupbyDispatch = (value: any) => {
    dispatch({ type: 'setGroupby', payload: value });
  };
  const setGroupDispatch = (value: any) => {
    dispatch({ type: 'setGroup', payload: value });
  };
  const setSumcolumnDispatch = (value: any) => {
    dispatch({ type: 'setSumcolumn', payload: value });
  };
  const setHiddenColumnNames = (hiddenColumns: any) => {
    dispatch({ type: 'setHiddenColumnNames', payload: hiddenColumns });
  };
  useEffect(() => {
    const slsData = summaryData?.data?.['getMonthlyReport']?.data || [];
    const balance = summaryData?.data?.['getMonthlyReport']?.message || null;
    const updatedRows = slsData.map((x: any) => x);
    const amount = isRaseed && balance ? JSON.parse(balance) : null;
    const isCredit = accvalue?.[0]?.accType === 2;
    if (amount !== null) {
      const { credit, debit } = amount;
      if (credit || debit) {
        const am = isCredit ? credit - debit : debit - credit;
        const isPlus = am >= 0;
        updatedRows.unshift({
          _id: `${Date.now()}`,
          accNameAr: 'رصيد افتتاحي',
          accName: 'Opening Balancee',
          opTime: `${start}`,
          opType: 94,
          credit:
            (isCredit && isPlus) || (!isCredit && !isPlus) ? Math.abs(am) : 0,
          debit:
            (isCredit && !isPlus) || (!isCredit && isPlus) ? Math.abs(am) : 0,
          amount: Math.abs(am),
        });
      }
    }

    let rased = 0;
    const updatedRows2 =
      updatedRows?.length > 0
        ? updatedRows.map((item: any) => {
            const rowRased = isCredit
              ? item.credit - item.debit
              : item.debit - item.credit;
            rased = rased + rowRased;
            return {
              ...item,
              amount: calculateAmount(item),
              rased,
            };
          })
        : [];

    const rdata = updateOpDocRefNumbers(updatedRows2);
    const totcredit = _.sumBy(rdata, 'credit');
    const totdebit = _.sumBy(rdata, 'debit');
    setDebit(totdebit);
    setCredit(totcredit);
    setRows(rdata);
  }, [summaryData, isRaseed]);

  const getIds = (list: any) =>
    list && list?.length > 0 ? list.map((sv: any) => sv._id) : undefined;
  const getPcode = (list: any) =>
    list && list?.length > 0 ? list.map((sv: any) => sv.code) : undefined;

  const fetchData = () => {
    const variables = {
      parentcodes: getPcode(paccvalue),
      accountIds: getIds(accvalue),
      departmentIds: getIds(departvalue),
      employeeIds: getIds(emplvalue),
      resourseIds: getIds(resovalue),
      contractIds: getIds(taskvalue),
      start: start ? start.setHours(0, 0, 0, 0) : undefined,
      end: end
        ? end.setHours(23, 59, 59, 999)
        : new Date().setHours(23, 59, 59, 999),
    };
    getSummary({
      variables,
    });
  };

  useEffect(() => {
    if (start && end) {
      fetchData();
    }
  }, [
    start,
    end,
    group,
    groupby,
    accvalue,
    paccvalue,
    sumcolumn,
    departvalue,
    emplvalue,
    resovalue,
    taskvalue,
  ]);

  const faccounts =
    paccvalue?.length > 0
      ? accounts.filter((ac: any) => ac?.parentcode === paccvalue?.[0]?.code)
      : accounts;

  const exporterRef: any = useRef(null);

  const startExport = useCallback(() => {
    exporterRef.current.exportGrid();
  }, [exporterRef]);

  const printRows = useMemo(() => {
    if (!rows) {
      return [];
    }
    return rows.map((r: any) => {
      const obj = { ...r };
      obj.opTime = covertToDate(obj.opTime);
      return obj;
    });
  }, [rows]);

  const onSave = (workbook: any) => {
    workbook.xlsx.writeBuffer().then((buffer: any) => {
      const now = new Date();
      const name = `finance-report-${covertToTimeDateDigit(now)}`;
      saveAs(
        new Blob([buffer], { type: 'application/octet-stream' }),
        `${name}.xlsx`
      );
    });
  };

  const onSwitcherChange = (e: any) => {
    if (e.target.value === 'none') {
      setGroupDispatch(false);
      setGroupbyDispatch('none');
    } else {
      setGroupDispatch(true);
      setGroupbyDispatch(e.target.value);
      setSumcolumnDispatch(col[e.target.value].name);
    }
  };

  const setSortDispatch = (value: any) => {
    dispatch({ type: 'setSort', payload: value });
  };

  const grouping = [{ columnName: sumcolumn }];
  const groupSummaryItems = [
    {
      columnName: col.opType.name,
      type: 'count',
      alignByColumn: true,
    },
    {
      columnName: 'credit',
      type: 'sum',
      alignByColumn: true,
    },
    {
      columnName: 'debit',
      type: 'sum',
      alignByColumn: true,
    },
  ];

  const totalSummaryItems = [
    { columnName: 'credit', type: 'sum' },
    { columnName: 'debit', type: 'sum' },
  ];

  const disgroup = [];
  if (!tempoptions?.project) disgroup.push(10);
  if (!tempoptions?.contract) disgroup.push(8);
  if (!tempoptions?.resourse) disgroup.push(11);
  if (!tempoptions?.department) disgroup.push(3);
  disgroup.push(4, 6, 7, 9, 12, 13);
  const groupOptions = groupList(isRTL).filter(
    (item: any) => !disgroup.includes(item.id)
  );

  const componentRef: any = useRef();

  const template = getDefaultTemplate(printtemplates, 'financereport');

  const handleReactPrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Finance Report`,
    removeAfterPrint: true,
  });

  const printData = {
    start,
    end,
    items: rows,
    rased: rows?.[rows?.length - 1]?.rased,
    isRTL,
    date: new Date(),
  };

  const bal = rows?.[rows?.length - 1]?.rased;
  return (
    <>
      {(accvalue?.length > 0 || paccvalue?.length > 0) && (
        <Box
          style={{
            position: 'absolute',
            left: isRTL ? 300 : undefined,
            right: isRTL ? undefined : 300,
            top: -8,
            zIndex: 112,
          }}
        >
          <PrintDownload
            company={company}
            printData={printData}
            componentRef={componentRef}
            handleReactPrint={handleReactPrint}
            isRTL={isRTL}
            template={template}
            no={'finance report'}
            element="financereport"
          ></PrintDownload>
        </Box>
      )}
      <Box
        display="flex"
        style={{
          position: 'absolute',
          top: 60,
          left: isRTL ? 100 : undefined,
          right: isRTL ? undefined : 100,
          zIndex: 112,
        }}
      >
        <Box
          display="flex"
          style={{
            height: 38,
            alignItems: 'center',
            justifyContent: 'flex-start',
            paddingLeft: 20,
            paddingRight: 20,
          }}
        >
          <Box
            style={{
              marginTop: -5,
            }}
          >
            <ReportGroupBySwitcher
              options={groupOptions}
              value={groupby}
              onChange={onSwitcherChange}
              isRTL={isRTL}
            ></ReportGroupBySwitcher>
          </Box>
          <Box style={{ width: 20 }}></Box>
          <FilterSelectCkeckBox
            options={mainaccounts}
            value={paccvalue?.[0]}
            setValue={setPaccvalueDispatch}
            words={words}
            isRTL={isRTL}
            name="paccount"
            label={isRTL ? 'الحسابات الرئيسية' : 'Main Accounts'}
            nomulti
            width={250}
          ></FilterSelectCkeckBox>
          <FilterSelectCkeckBox
            options={faccounts}
            value={accvalue?.[0]}
            setValue={setAccvalueDispatch}
            words={words}
            isRTL={isRTL}
            name="account"
            nomulti
            width={250}
          ></FilterSelectCkeckBox>
        </Box>
        <Box style={{ marginLeft: 10, marginRight: 10 }}>
          <FormControlLabel
            control={
              <Checkbox
                style={{ padding: 7 }}
                checked={isRaseed}
                onChange={() => setIsRaseed(!isRaseed)}
                color="primary"
              />
            }
            disabled={!accvalue?.[0]}
            label={
              <Typography
                style={{ color: theme.palette.primary.main }}
                variant="subtitle2"
              >
                {isRTL ? 'رصيد افتتاحي' : 'Opening Balance'}
              </Typography>
            }
            style={{ fontSize: 14, opacity: !accvalue?.[0] ? 0.3 : 1 }}
          />
        </Box>
      </Box>
      <Box
        display="flex"
        style={{
          position: 'absolute',
          alignItems: 'center',
          justifyContent: 'flex-end',
          width: '50%',
          paddingLeft: 50,
          paddingRight: 50,
          top: 5,
          left: isRTL ? 520 : undefined,
          right: isRTL ? undefined : 520,
        }}
      >
        <MUIGrid container spacing={2}>
          {tempoptions?.contract && (
            <MUIGrid item xs={4}>
              <FilterSelectMulti
                options={tasks}
                value={taskvalue}
                setValue={setTaskvalueDispatch}
                words={words}
                isRTL={isRTL}
                name="task"
                fullwidth
              ></FilterSelectMulti>
            </MUIGrid>
          )}
          {tempoptions?.department && (
            <MUIGrid item xs={4}>
              <FilterSelectMulti
                options={departments}
                value={departvalue}
                setValue={setDepartvalueDispatch}
                words={words}
                isRTL={isRTL}
                name="department"
                fullwidth
              ></FilterSelectMulti>
            </MUIGrid>
          )}

          <MUIGrid item xs={4}>
            <FilterSelectMulti
              options={employees}
              value={emplvalue}
              setValue={setEmplvalueDispatch}
              words={words}
              isRTL={isRTL}
              name="employee"
              fullwidth
            ></FilterSelectMulti>
          </MUIGrid>
          {tempoptions?.resourse && (
            <MUIGrid item xs={4}>
              <FilterSelectMulti
                options={resourses}
                value={resovalue}
                setValue={setResovalueDispatch}
                words={words}
                isRTL={isRTL}
                name="resourse"
                fullwidth
              ></FilterSelectMulti>
            </MUIGrid>
          )}
        </MUIGrid>
      </Box>
      <Box
        style={{
          position: 'absolute',
          zIndex: 111,
          left: isRTL ? undefined : drawerWidth + 225,
          right: isRTL ? drawerWidth + 225 : undefined,
          bottom: 2,
          display: 'flex',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Typography
          style={{
            fontWeight: 'bold',
            color: debit < 0 ? colors.red[500] : colors.blue[500],
            marginLeft: 20,
            marginRight: 20,
          }}
        >
          {isRTL ? 'مدين' : 'Debit'}: {moneyFormat(debit)}
        </Typography>
        <Typography
          style={{
            fontWeight: 'bold',
            color: credit < 0 ? colors.red[500] : colors.blue[500],
            marginLeft: 20,
            marginRight: 20,
          }}
        >
          {isRTL ? 'دائن' : 'Credit'}: {moneyFormat(credit)}
        </Typography>
        <Typography
          style={{
            fontWeight: 'bold',
            color: bal < 0 ? colors.red[500] : colors.blue[500],
            marginLeft: 20,
            marginRight: 20,
          }}
        >
          {isRTL ? 'الرصيد' : 'Balance'}: {moneyFormat(bal)}
        </Typography>
      </Box>
      <Grid rows={rows} columns={columns} getRowId={getRowId}>
        <SortingState
          defaultSorting={sort}
          onSortingChange={(srt: any) => setSortDispatch(srt)}
        />
        <DragDropProvider />
        {group && <GroupingState grouping={grouping} />}
        {group && (
          <SummaryState
            totalItems={totalSummaryItems}
            groupItems={groupSummaryItems}
          />
        )}
        {group && <IntegratedGrouping />}
        {group && <IntegratedSummary />} <IntegratedSorting />
        <SearchState />
        <IntegratedFiltering />
        <VirtualTable
          height={height - 98}
          tableComponent={!group ? TableComponent : TableComponent2}
          messages={{
            noData: isRTL ? 'لا يوجد بيانات' : 'no data',
          }}
          estimatedRowHeight={30}
          columnExtensions={tableColumnExtensions}
        />
        <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />
        <TableHeaderRow
          showSortingControls
          titleComponent={({ children }) => {
            return (
              <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                {children}
              </Typography>
            );
          }}
        />
        <TableColumnVisibility
          defaultHiddenColumnNames={hiddenColumnNames}
          hiddenColumnNames={hiddenColumnNames}
          onHiddenColumnNamesChange={setHiddenColumnNames}
        />
        <DataTypeProvider
          for={['opTime']}
          formatterComponent={opTimeFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['credit', 'debit', 'rased']}
          formatterComponent={currencyFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['opType']}
          formatterComponent={opTypeFormatter}
        ></DataTypeProvider>
        <Toolbar />
        <ColumnChooser />
        <SearchPanel
          inputComponent={(props: any) => {
            return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
          }}
        />
        <ExportPanel startExport={startExport} />
        {group && (
          <TableGroupRow
            messages={{
              sum: isRTL ? 'المجموع' : 'Total',
              count: isRTL ? 'العدد' : 'Count',
              sumOf: isRTL ? 'المجموع' : 'Total',
              countOf: isRTL ? 'العدد' : 'Count',
            }}
            showColumnsWhenGrouped
          />
        )}
        {group && (
          <TableSummaryRow
            messages={{
              sum: isRTL ? 'المجموع' : 'Total',
              count: isRTL ? 'العدد' : 'Count',
            }}
          ></TableSummaryRow>
        )}
      </Grid>
      <GridExporter
        ref={exporterRef}
        rows={printRows}
        columns={columns}
        onSave={onSave}
      />
    </>
  );
}
